
// You can write more code here

/* START OF COMPILED CODE */

import ChunkBase from "../../ChunkBase";
import ChunkBoundaries from "../../../components/ChunkBoundaries";
import BoundsMarker from "../../editor/BoundsMarker";
import DecorationFloatingPoleLong from "../../decorations/shipwreck/DecorationFloatingPoleLong";
import PlatformMarkerJungleLog from "../../editor/platform-markers/jungle/PlatformMarkerJungleLog";
import PlatformMarkerCabin from "../../editor/platform-markers/shipwreck/PlatformMarkerCabin";
import SmallGemMarker from "../../editor/entity-markers/SmallGemMarker";
import MegaGemMarker from "../../editor/entity-markers/MegaGemMarker";
import PlatformMarkerJungleLogLong from "../../editor/platform-markers/jungle/PlatformMarkerJungleLogLong";
import PlatformMarkerBarrel from "../../editor/platform-markers/shipwreck/PlatformMarkerBarrel";
import PlatformMarkerSubmergedBarrel from "../../editor/platform-markers/shipwreck/PlatformMarkerSubmergedBarrel";
import CheckpointMarker from "../../editor/CheckpointMarker";
import MoverData from "../../../components/platformer/MoverData";
import PositionMarker from "../../editor/PositionMarker";
import SmashableMarkerCrate from "../../editor/entity-markers/SmashableMarkerCrate";
import SimpleBreakableBlocker from "../../../components/platformer/SimpleBreakableBlocker";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class ShipwreckChunkHard3 extends ChunkBase {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 0, y ?? 384);

    // editor_bounds_left
    const editor_bounds_left = new BoundsMarker(scene, 221, 267);
    this.add(editor_bounds_left);

    // editor_bounds_right
    const editor_bounds_right = new BoundsMarker(scene, 5066, 267);
    this.add(editor_bounds_right);

    // pole_long_float_png_1
    const pole_long_float_png_1 = new DecorationFloatingPoleLong(scene, 541, 139);
    this.add(pole_long_float_png_1);

    // pole_long_float_png
    const pole_long_float_png = new DecorationFloatingPoleLong(scene, 230, 139);
    this.add(pole_long_float_png);

    // platformLog_2
    const platformLog_2 = new PlatformMarkerJungleLog(scene, 946, -252);
    this.add(platformLog_2);

    // platformCabin
    const platformCabin = new PlatformMarkerCabin(scene, 1441, 207);
    this.add(platformCabin);

    // platformLog_5
    const platformLog_5 = new PlatformMarkerJungleLog(scene, 1960, -688);
    this.add(platformLog_5);

    // gemMarker
    const gemMarker = new SmallGemMarker(scene, 935, -305);
    this.add(gemMarker);

    // gemMarker_1
    const gemMarker_1 = new SmallGemMarker(scene, 1459, -565);
    this.add(gemMarker_1);

    // platformLog_7
    const platformLog_7 = new PlatformMarkerJungleLog(scene, 2626, -3);
    this.add(platformLog_7);

    // pole_long_float_png_6
    const pole_long_float_png_6 = new DecorationFloatingPoleLong(scene, 2454, 140);
    this.add(pole_long_float_png_6);

    // pole_long_float_png_7
    const pole_long_float_png_7 = new DecorationFloatingPoleLong(scene, 2783, 140);
    this.add(pole_long_float_png_7);

    // gemMarker_6
    const gemMarker_6 = new SmallGemMarker(scene, 1396, 103);
    this.add(gemMarker_6);

    // gemMarker_7
    const gemMarker_7 = new SmallGemMarker(scene, 1513, 99);
    this.add(gemMarker_7);

    // gemMarker_8
    const gemMarker_8 = new SmallGemMarker(scene, 1760, 143);
    this.add(gemMarker_8);

    // gemMarker_10
    const gemMarker_10 = new SmallGemMarker(scene, 4321, -68);
    this.add(gemMarker_10);

    // gemMarker_11
    const gemMarker_11 = new SmallGemMarker(scene, 1947, -753);
    this.add(gemMarker_11);

    // gemMarker_12
    const gemMarker_12 = new SmallGemMarker(scene, 4552, -71);
    this.add(gemMarker_12);

    // gemMarker_13
    const gemMarker_13 = new SmallGemMarker(scene, 932, -55);
    this.add(gemMarker_13);

    // gemMarker_14
    const gemMarker_14 = new SmallGemMarker(scene, 424, -64);
    this.add(gemMarker_14);

    // megaGemMarker
    const megaGemMarker = new MegaGemMarker(scene, 3494, -812);
    this.add(megaGemMarker);

    // megaGemMarker_1
    const megaGemMarker_1 = new MegaGemMarker(scene, 2097, 150);
    this.add(megaGemMarker_1);

    // megaGemMarker_2
    const megaGemMarker_2 = new MegaGemMarker(scene, 2727, -63);
    this.add(megaGemMarker_2);

    // platformMarkerLogLong
    const platformMarkerLogLong = new PlatformMarkerJungleLogLong(scene, 682, -2);
    this.add(platformMarkerLogLong);

    // pole_long_float_png_8
    const pole_long_float_png_8 = new DecorationFloatingPoleLong(scene, 832, 139);
    this.add(pole_long_float_png_8);

    // pole_long_float_png_9
    const pole_long_float_png_9 = new DecorationFloatingPoleLong(scene, 1118, 139);
    this.add(pole_long_float_png_9);

    // pole_long_float_png_10
    const pole_long_float_png_10 = new DecorationFloatingPoleLong(scene, 4738, 139);
    this.add(pole_long_float_png_10);

    // pole_long_float_png_11
    const pole_long_float_png_11 = new DecorationFloatingPoleLong(scene, 4474, 139);
    this.add(pole_long_float_png_11);

    // pole_long_float_png_12
    const pole_long_float_png_12 = new DecorationFloatingPoleLong(scene, 4183, 139);
    this.add(pole_long_float_png_12);

    // pole_long_float_png_13
    const pole_long_float_png_13 = new DecorationFloatingPoleLong(scene, 3910, 139);
    this.add(pole_long_float_png_13);

    // platformMarkerLogLong_3
    const platformMarkerLogLong_3 = new PlatformMarkerJungleLogLong(scene, 4324, 9);
    this.add(platformMarkerLogLong_3);

    // platformBarrel
    const platformBarrel = new PlatformMarkerBarrel(scene, 2848, -702);
    this.add(platformBarrel);

    // platformBarrel_2
    const platformBarrel_2 = new PlatformMarkerBarrel(scene, 3492, -702);
    this.add(platformBarrel_2);

    // platformMarkerSubmergedBarrel
    const platformMarkerSubmergedBarrel = new PlatformMarkerSubmergedBarrel(scene, 1747, 237);
    this.add(platformMarkerSubmergedBarrel);

    // platformMarkerSubmergedBarrel_1
    const platformMarkerSubmergedBarrel_1 = new PlatformMarkerSubmergedBarrel(scene, 2087, 235);
    this.add(platformMarkerSubmergedBarrel_1);

    // checkpointMarker
    const checkpointMarker = new CheckpointMarker(scene, 422, -34);
    this.add(checkpointMarker);

    // checkpointMarker_2
    const checkpointMarker_2 = new CheckpointMarker(scene, 4084, -25);
    this.add(checkpointMarker_2);

    // platformBarrel_3
    const platformBarrel_3 = new PlatformMarkerBarrel(scene, 1460, -438);
    this.add(platformBarrel_3);

    // platformLog_1
    const platformLog_1 = new PlatformMarkerBarrel(scene, 2453, -709);
    this.add(platformLog_1);

    // positionMarker
    const positionMarker = new PositionMarker(scene, 2453, -703);
    this.add(positionMarker);

    // positionMarker_1
    const positionMarker_1 = new PositionMarker(scene, 2586, -703);
    this.add(positionMarker_1);

    // platformLog
    const platformLog = new PlatformMarkerBarrel(scene, 3141, -708);
    this.add(platformLog);

    // positionMarker_2
    const positionMarker_2 = new PositionMarker(scene, 3141, -702);
    this.add(positionMarker_2);

    // positionMarker_3
    const positionMarker_3 = new PositionMarker(scene, 3274, -702);
    this.add(positionMarker_3);

    // platformBarrel_1
    const platformBarrel_1 = new PlatformMarkerBarrel(scene, 3778, -595);
    this.add(platformBarrel_1);

    // megaGemMarker_3
    const megaGemMarker_3 = new MegaGemMarker(scene, 3777, -709);
    this.add(megaGemMarker_3);

    // crateMarker_1
    const crateMarker_1 = new SmashableMarkerCrate(scene, 2611, -143);
    this.add(crateMarker_1);

    // platformBarrel_4
    const platformBarrel_4 = new PlatformMarkerBarrel(scene, 3217, 55);
    this.add(platformBarrel_4);

    // gemMarker_2
    const gemMarker_2 = new SmallGemMarker(scene, 3217, -86);
    this.add(gemMarker_2);

    // platformBarrel_5
    const platformBarrel_5 = new PlatformMarkerBarrel(scene, 3481, 124);
    this.add(platformBarrel_5);

    // gemMarker_3
    const gemMarker_3 = new SmallGemMarker(scene, 3481, -17);
    this.add(gemMarker_3);

    // platformLog_3
    const platformLog_3 = new PlatformMarkerJungleLog(scene, 2616, -295);
    this.add(platformLog_3);

    // this (components)
    const thisChunkBoundaries = new ChunkBoundaries(this);
    thisChunkBoundaries.leftBoundsMarker = editor_bounds_left;
    thisChunkBoundaries.rightBoundsMarker = editor_bounds_right;

    // platformLog_1 (components)
    const platformLog_1MoverData = new MoverData(platformLog_1);
    platformLog_1MoverData.startMarker = positionMarker;
    platformLog_1MoverData.endMarker = positionMarker_1;
    platformLog_1MoverData.startWait = 800;

    // platformLog (components)
    const platformLogMoverData = new MoverData(platformLog);
    platformLogMoverData.startMarker = positionMarker_2;
    platformLogMoverData.endMarker = positionMarker_3;
    platformLogMoverData.startWait = 800;

    // crateMarker_1 (components)
    const crateMarker_1SimpleBreakableBlocker = SimpleBreakableBlocker.getComponent(crateMarker_1);
    crateMarker_1SimpleBreakableBlocker.allowedCharacter = "ice";
    // awake handler
    this.scene.events.once("scene-awake", () => this.awake());

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
